<script setup lang="ts">
import ItemMenu from '../list-item/ItemMenu.vue';

const MENU_ITEMS = [
  { icon: 'mi-bird', label: 'Mixit Klub', to: { name: 'clubPath' } },
  { icon: 'mi-cart-fill', label: 'Partnerské prodejny', to: { name: 'distributorsPath' } },
  { icon: 'mi-box', label: 'Pro firmy', to: { name: 'companyGiftsPath' } },
  { icon: 'mi-return', label: 'Reklamace', to: { name: 'complaintsPath' } },
  { icon: 'mi-info', label: 'Otázky (FAQ)', to: { name: 'faqPath' } },
  { icon: 'mi-article', label: 'Blog', to: { name: 'blogPath' } },
  { icon: 'mi-bird', label: 'O nás', to: { name: 'aboutUsPath' } },
  { icon: 'mi-announcement', label: 'Kariéra', to: { name: 'jobOfferPath' } },
  { icon: 'mi-phone', label: 'Kontakt', to: { name: 'contactPath' } },
];
</script>

<template>
  <div class="flex flex-col bg-white rounded-lg shadow overflow-hidden w-70">
    <template
      v-for="(item, index) in MENU_ITEMS"
      :key="index"
    >
      <ItemMenu
        :icon="item.icon"
        :label="item.label"
        :router-to="item.to"
      />
      <hr
        v-if="index < (MENU_ITEMS.length - 1)"
        class="w-full h-px bg-brown-100 border-none"
      >
    </template>
  </div>
</template>
